import { render, staticRenderFns } from "./ShadowContent.vue?vue&type=template&id=6bcc6388&"
import script from "./ShadowContent.vue?vue&type=script&lang=js&"
export * from "./ShadowContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports